module.exports = __webpack_public_path__ + "static/media/Digital_01.d91263d2.jpg";